<template>
  <div class="flex flex-col justify-end items-end w-4">
    {{ index + 1 }}
    <img
      v-if="item.isAIIndicatorVisible"
      src="@/assets/images/ai-generator/ai-indicator.svg"
      v-tooltip="$i18nPresenter.t('AI-powered content. Review before presenting.')"
    />
    <span
      v-if="item.notes"
      v-tooltip="{content: $i18nPresenter.t('This slide has a note')}"
      class="aha-slide-has-note group"
      @click="$emit('focusNoteAndMakeSlideActive' , item )"
    >
      <aha-icon
        class="inline group-hover:hidden"
        name="note-side-left"
        width="20"
        viewBox="0 0 25 24"
      />
      <aha-icon
        class="hidden group-hover:inline"
        name="note-side-left-fill"
        width="20"
        viewBox="0 0 25 24"
      />
    </span>
  </div>
</template>
<script >
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
}
</script>
<style scoped>
.aha-slide-has-note {
  @apply  text-secondary-40 hover:text-brand-b100 cursor-pointer;
}
</style>
